import dynamic from 'next/dynamic';
import { RfpConfirmationProps } from './RfpConfirmation.types';

export const RfpConfirmation = dynamic<{ model: RfpConfirmationProps }>(() =>
  import('./RfpConfirmation').then(mod => mod.RfpConfirmation)
);
